import { ProcessModelParams } from "../services/state/Process-modular/processModular-interface";

export const createProcessModelParams = (
  versionUuid: string,
  folderUuid: string,
  roles: { users: string; groupUuid: string; name: string }[],
  processVariables: any[],
  pmDetails: {
    uuid: string;
    name: string;
    description: string;
    displayName: string;
    version: string;
  },
  nodes: any[],
  edges: any[]
): ProcessModelParams => {
  return {
    processModelDtls: {
      versionUuid,
      folderUuid,
      roleMap: {
        role: roles.map((role) => ({
          users: role.users,
          groups: { groupUuid: role.groupUuid },
          name: role.name,
        })),
      },
      process_model: {
        pm: {
          meta: {
            uuid: pmDetails.uuid,
            name: {
              localeList: [
                {
                  locale: { country: "US", lang: "en" },
                  value: pmDetails.name,
                },
              ],
            },
            displayName: {
              localeList: [
                {
                  locale: { country: "US", lang: "en" },
                  value: pmDetails.displayName,
                },
              ],
            },
            desc: {
              "string-map": {
                pair: [
                  {
                    locale: { country: "US", lang: "en" },
                    value: pmDetails.description,
                  },
                ],
              },
            },
            versionStatus: pmDetails.version,
            "pm-notification-settings": {
              "custom-settings": "true",
              "notify-initiator": "false",
              "notify-owner": "false",
              usersandgroups: {
                people: {
                  type: "4096",
                  stringId: "273449ad-ec7e-4fcf-98a5-67e64308ee82",
                },
              },
              "recipients-exp": "",
            },
            "cleanup-action": "1",
            "auto-archive-delay": "1",
            "auto-delete-delay": "1",
            timeZoneId: "Asia/Kolkata",
            useProcessInitiatorTimeZone: "true",
          },
          pvs: processVariables,
          nodes: nodes,
          edges: edges || [],
        },
      },
      isPublished: "true",
      history: {
        historyInfo: { versionUuid: "1" },
      },
    },
  };
};
